<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getToken } from '@/utils/auth.js'
import { myDebounce } from '@/utils'
export default {
  name: 'App',
  data() {
    return {
      zoomSize: 1,
      homeZoomSize: 1
    }
  },
  watch: {
    '$route': function(to, from) {
      const APP = document.getElementById('app')
      APP.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  created() {
    var user = localStorage.getItem('user')
    if (user) {
      user = JSON.parse(user)
      this.$store.commit('user/setUser', user)
    }
    var applyActive = localStorage.getItem('applyActive')
    if (applyActive) {
      this.$store.commit('library/setApplyActive', applyActive)
    }
    const token = getToken()
    if (token) {
      this.$store.dispatch('user/messageActions')
    }
  },
  mounted() {
    // const that = this
    function setZoom() {
      const zoom = window.innerWidth / 1920
      // if (['/', '/home'].includes(that.$route.path)) {
      //   // const home = document.getElementById('home')
      //   // that.homeZoomSize = window.innerHeight / home.clientHeight
      //   that.homeZoomSize = window.innerHeight / 1033
      // }
      // that.zoomSize = zoom < that.homeZoomSize ? zoom : that.homeZoomSize
      // const APP = document.getElementById('app')
      // document.body.style.zoom = that.zoomSize
      document.body.style.zoom = zoom
    }
    setZoom()
    window.addEventListener('resize', myDebounce(setZoom, 200))
  }

}
</script>
<style lang="scss">
#app {
  position: relative;
  top: 0px;
  bottom: 0px;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y:scroll ;
}
</style>
